import { inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

export interface INavBarItem {
  name: string;
  icon: string;
  routerLink: string;
  tooltip: string;
  roles?: string[];
  disabled?: boolean;
}

export const NAV_BAR_ITEMS = new InjectionToken<Observable<INavBarItem[]>>('NAV_BAR_ITEMS');

const navBarItemsFactory = (authService: AuthService) => {
  // `tooltip` is derived from `name` below, so it is absent here on purpose.
  const items: Omit<INavBarItem, 'tooltip'>[] = [
    {
      name: 'title.workspaces',
      icon: 'ri-file-copy-2-line',
      routerLink: '/workspaces',
    },
    {
      name: 'title.users',
      icon: 'ri-group-line',
      routerLink: '/users',
      // Every role can view the org users list; management actions are gated inside the page.
      roles: ['admin', 'analyst', 'analystmanager', 'technician', 'technicianmanager'],
    },
    {
      name: 'title.protocols',
      icon: 'ri-briefcase-2-line',
      routerLink: '/protocols',
      roles: ['admin'],
    },
    {
      name: 'title.devices',
      icon: 'ri-device-line',
      routerLink: '/devices',
      roles: ['admin'],
    },
    {
      name: 'title.organizations',
      icon: 'ri-archive-drawer-line',
      routerLink: '/organizations',
      roles: ['admin'],
    },
    {
      name: 'title.billing',
      icon: 'ri-calculator-line',
      routerLink: '/billing',
      roles: ['admin'],
      disabled: true,
    },
  ];

  return authService.currentOrganization$.pipe(
    map((currentOrg) => {
      return items.map((item) => ({
        ...item,
        // A tooltip on a labelled item confirms the label; it must not
        // introduce a second name for the same destination.
        tooltip: item.name,
        disabled: item.disabled || !currentOrg,
      }));
    })
  );
};

export const navBarItemsProvider = {
  provide: NAV_BAR_ITEMS,
  useFactory: navBarItemsFactory,
  deps: [AuthService],
};
